import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateCoupon } from "./createCoupon.request";

const useCreateCoupon = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateCoupon,
    ...options
  });
};

export default useCreateCoupon;
